import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import {
  useAgregarInteraccionMutation,
  useLazyVerPolizaQuery,
  useVerPolizaQuery,
} from "../services/docs";
import { Spinner } from "../components/Spinner";
import { CardCliente } from "../components/CardCliente";
import { RootState } from "../store";
import { TablaEventosComponent } from "../components/TablaEventosComponent";
import { LlamadaPendienteComponent } from "../components/LlamadaPendienteComponent";
import Button from "../components/ui/Button";
import { toastr } from "react-redux-toastr";
import { agregarLlamadaID, agregarSeleccion } from "../features/ui/uiSlice";
import { useEffect, useState } from "react";
import { ItemTabComponent } from "../components/ItemTabComponent";
import { Icon } from "../components/ui/Icon";
import { TablaEventosNuevosComponent } from "../components/TablaEventosNuevosComponent";

export const PolizaLayout = () => {
  const { seleccion, p_seleccion } = useSelector(
    (state: RootState) => state.ui
  );
  const [verAction, { data, isLoading }] = useLazyVerPolizaQuery();
  const [agregarInteraccionAction, { isLoading: isLInteraccion }] =
    useAgregarInteraccionMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    verAction(seleccion);
  }, []);
  useEffect(() => {
    if (data) {
      if (data.llamada.length > 0) {
        dispatch(agregarLlamadaID({ fi_llamada_id: data.llamada[0].id }));
      }
      if (data.ids_nuevo) {
        dispatch(agregarSeleccion(data.ids_nuevo));
      }
    }
  }, [data]);

  const IrA = (ruta: string) => {
    navigate(`/home/ver/${ruta}`);
  };
  const agregarInteraccion = async () => {
    const resp = await agregarInteraccionAction({ fc_id: seleccion })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        } else {
          toastr.error(err.data.message);
        }
      });
    if (resp) {
      toastr.success(resp.message);
      dispatch(agregarSeleccion(resp.ids));
      verAction(resp.ids);
    }
  };
  if (isLoading || !data) {
    return (
      <div className="flex w-full justify-center">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <div className="w-full p-2 ">
        {!isLoading && data.informacion && (
          <>
            <div className=" space-2 grid w-full grid-cols-5 gap-4 rounded-xl  ">
              <ItemTabComponent
                p_seleccion={p_seleccion}
                seccion={"p-informacion"}
                nombre={"informacion"}
                titulo={"Información"}
                icono={<Icon variante="informacion" />}
              />
              <ItemTabComponent
                p_seleccion={p_seleccion}
                seccion={"p-siniestros"}
                nombre={"siniestros"}
                titulo={"Siniestros"}
                icono={<Icon variante="siniestros" />}
              />
              <ItemTabComponent
                p_seleccion={p_seleccion}
                seccion={"p-cancelacion"}
                nombre={"cancelacion"}
                titulo={"Cancelación"}
                icono={<Icon variante="cancelacion" />}
              />
              <ItemTabComponent
                p_seleccion={p_seleccion}
                seccion={"p-endoso"}
                nombre={"endoso"}
                titulo={"Endosos"}
                icono={<Icon variante="endoso" />}
              />
              <ItemTabComponent
                p_seleccion={p_seleccion}
                seccion={"p-cobranza"}
                nombre={"cobranza"}
                titulo={"Cobranza"}
                icono={<Icon variante="cobranza" />}
              />
            </div>
          </>
        )}
      </div>
      <div className="mt-5 flex flex-wrap">
        <div className="w-full  p-2 md:w-3/4">
          <div className="card mb-5 rounded-xl p-0">
            <div className="w-full">
              <Outlet />
            </div>
          </div>
          {!isLoading && data && (
            <LlamadaPendienteComponent
              llamada={data.llamada}
              tt_llamada={data.tt_llamada}
              interacciones={data.interacciones}
              agregarInteraccion={agregarInteraccion}
              isLoading={isLInteraccion}
              medio_contratacion={data.medio_contratacion}
              tipo_llamada={data.tipo_llamada}
            />
          )}
        </div>

        <div className="w-full p-2  md:w-1/4">
          <CardCliente informacion={data.informacion} />
        </div>
      </div>

      <div className="card rounded-xl p-0">
        <div className="w-full">
          <h1 className="mb-5 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
            Eventos Anteriores
          </h1>
          {!isLoading && data.eventos && (
            <TablaEventosComponent data={data.eventos} />
          )}
          {!isLoading && data.llamada_anteriores && (
            <TablaEventosNuevosComponent data={data.llamada_anteriores} />
          )}
        </div>
      </div>
    </>
  );
};
